module.exports = __webpack_public_path__ + "img/Logo_Full_Green_Trans.2b766500.png";